"use client";
import { useSearchParams } from "next/navigation";
import { useSelector } from "react-redux";
import { useWeglot } from "@stadium/services/weglot/provider";
import { useStoreContext } from "@components/store/provider";
import useProductDetailsModal from "@hooks/product-detail/use-product-details-modal";

import { getReceivedItemsCount } from "@selectors/cart";
import { getIsPricelessShop } from "@selectors/store";

import { ExternalButton, InternalButton } from "@sharedComponents/buttons";

import { getSelectedLanguage, isForceTranslationsEnabled } from "@stadium/services/weglot/helpers";
import { generateUrlByQuery } from "@stadium/helpers/dom";
import { generateQueryForRoutePath } from "@stadium/helpers/store";

import { DEFAULT_LANG_OBJ } from "@stadium/services/weglot/constants";

import styles from "./main.module.scss";

const LinkWithLang = ({ pathname, query, origin, children, product, ...rest }) => {
  const searchParams = useSearchParams();
  const forceTranslations = isForceTranslationsEnabled(searchParams);

  const {
    isPreviewCatalogMode,
    isNewRoute,
    countryCode,
    storeCode,
    storeNumber,
    workspaceSlug,
    lang,
  } = useStoreContext();

  const isPricelessShop = useSelector(getIsPricelessShop);
  const isRLPFlow = useSelector(getReceivedItemsCount);

  const { openProductDetailsModalCatalog, renderProductDetailsModalCatalog } =
    useProductDetailsModal();

  const { availableLanguages, instance } = useWeglot();

  const selectedLanguage = getSelectedLanguage({
    weglotLanguages: availableLanguages,
    langInUrl: forceTranslations ? lang : "",
    weglotInstance: instance,
    forceTranslations,
  });

  const href = generateUrlByQuery({
    pathname,
    query: generateQueryForRoutePath({
      countryCode,
      lang: selectedLanguage ?? DEFAULT_LANG_OBJ.key,
      storeNumber,
      slug: storeCode,
      workspaceSlug,
      isNewRoute,
      ...query,
    }),
  });

  const isRenderProductDetailModal = isPreviewCatalogMode || (isPricelessShop && !isRLPFlow);

  return (
    <>
      {isRenderProductDetailModal && product ? (
        <InternalButton
          styleType="no-style"
          className={styles.productCatalogCardHolder}
          onClick={openProductDetailsModalCatalog}
          displayChildren={false}
          {...rest}
        >
          {children}
        </InternalButton>
      ) : (
        <ExternalButton
          href={href}
          styleType="no-style"
          target="_blank"
          {...rest}
          displayChildren={false}
        >
          {children}
        </ExternalButton>
      )}
      {isRenderProductDetailModal && renderProductDetailsModalCatalog({ data: product })}
    </>
  );
};

export default LinkWithLang;
